import type { ComponentPropsWithoutRef, ReactNode } from "react";
import * as RadixDialog from "@radix-ui/react-dialog";
import s from "./Dialog.module.css";

export const Dialog = RadixDialog.Root;
export const DialogTrigger = RadixDialog.Trigger;
export const DialogClose = RadixDialog.Close;
export const DialogTitle = RadixDialog.Title;
export const DialogDescription = RadixDialog.Description;

export interface DialogContentProps extends ComponentPropsWithoutRef<typeof RadixDialog.Content> {
  children: ReactNode;
}

export function DialogContent({ className, children, ...rest }: DialogContentProps) {
  const classes = className ? `${s.content} ${className}` : s.content;
  return (
    <RadixDialog.Portal>
      <RadixDialog.Overlay className={s.overlay} />
      <RadixDialog.Content className={classes} {...rest}>
        {children}
      </RadixDialog.Content>
    </RadixDialog.Portal>
  );
}
